import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center vertical-flow__form__step contact-container"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "pb-5 text-left contact-container__contact" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "contact-container__contact__type__icon contact-container__contact__type__icon--phone" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Ring til os", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "contact-container__contact__type__icon contact-container__contact__type__icon--mail" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Skriv til os", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "contact-container__contact__type__icon contact-container__contact__type__icon--sale" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Få et samlet tilbud", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkComponent = _resolveComponent("LinkComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    ((_ctx.showCall || _ctx.showWrite || _ctx.showOffer) && !_ctx.hide)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", {
            class: "mb-4",
            innerHTML: _ctx.cms.questionTitle
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.showCall)
              ? (_openBlock(), _createBlock(_component_LinkComponent, {
                  key: 0,
                  class: "contact-container__contact__type",
                  "data-gtm": _ctx.cms.dataGtm,
                  "data-gtm-click-text": "ring-til-os",
                  externalIcon: false,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal(true)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["data-gtm"]))
              : _createCommentVNode("", true),
            (_ctx.showWrite)
              ? (_openBlock(), _createBlock(_component_LinkComponent, {
                  key: 1,
                  class: "contact-container__contact__type",
                  "data-gtm": _ctx.cms.dataGtm,
                  "data-gtm-click-text": "skriv-til-os",
                  externalIcon: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cms.contactDirectMail ? undefined : _ctx.openModal(false))),
                  to: _ctx.cms.contactDirectMail ? _ctx.cms.contactMailTo : undefined,
                  target: _ctx.cms.contactDirectMail ? '_blank' : undefined
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["data-gtm", "to", "target"]))
              : _createCommentVNode("", true),
            (_ctx.showOffer)
              ? (_openBlock(), _createBlock(_component_LinkComponent, {
                  key: 2,
                  class: "contact-container__contact__type",
                  to: _ctx.cms.samletTilbudLink,
                  target: "_blank",
                  externalIcon: true,
                  smallIcon: true,
                  rel: "noopener",
                  "data-gtm": _ctx.cms.dataGtm,
                  "data-gtm-click-text": "samletilbud"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["to", "data-gtm"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}